<template>
  <div class="content-wrapper">
    <h2 class="page-titles">User Management</h2>
    <template v-if="isTeamOwner">
      <Tabs :tabs="tabs" @setActiveTab="setActiveTab($event)" />
      <transition name="slide-fade">
        <ManageUsers
          v-if="tabs[0].isActive"
          @subscribed="setActiveTab($event)"
        />
        <ManageTeams v-if="tabs[1].isActive && isTeamOwner" />
      </transition>
    </template>
    <template v-else>
      <ManageUsers />
    </template>
  </div>
</template>

<script>
import { layouts } from '../helpers'
import { mapState } from 'vuex'

export default {
  name: 'UsersMain',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  },
  data() {
    return {
      tabs: [
        { name: 'Manage Users', isActive: true },
        { name: 'Teams', isActive: false }
      ]
    }
  },
  components: {
    Tabs: () => import('../components/Universal/Tabs'),
    ManageUsers: () => import('../components/Members/ManageUsers'),
    ManageTeams: () => import('../components/Subteams/ManageTeams')
  },
  methods: {
    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    }
  },
  computed: {
    ...mapState({
      isTeamOwner() {
        return this.$store.getters['profile/isTeamOwner']
      }
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0 cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0.5;
}
</style>
